var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NavBar from "../../organisms/navBar/navBar";
import "../../templates/general_page_template.css";
import Card from "../../atoms/card/card";
import "../../styles/text.css";
import "./userGuide.css";
import userGuideJobseeker from "./userGuideJobseeker.json";
import userGuideAdviser from "./userGuideAdviser.json";
import userGuideManager from "./userGuideManager.json";
import userGuideOrganisation from "./userGuideOrganisation.json";
import userGuideSuperOrg from "./userGuideSuperOrg.json";
import PageHeader from "../../organisms/pageHeader/pageHeader";
import { useSelector } from "react-redux";
export default function UserGuide(props) {
    var data = [];
    var userType = useSelector(function (state) { return state.rootReducer.userReducer.userType; });
    var text = userGuideJobseeker;
    switch (props.viewing_user || userType) {
        case "superorg":
            text = userGuideSuperOrg;
            break;
        case "organisation":
            text = userGuideOrganisation;
            break;
        case "manager":
            text = userGuideManager;
            break;
        case "adviser":
            text = userGuideAdviser;
            break;
        case "jobseeker":
        default:
            text = userGuideJobseeker;
            break;
    }
    for (var i = 0; i < text.length; i += 2) {
        data.push(_jsxs("li", __assign({ className: "list-item list-inside my-4" }, { children: [_jsx("p", __assign({ className: "text-text inline underline" }, { children: text[i] })), _jsx("ul", __assign({ className: "list-item ml-4" }, { children: _jsx("li", __assign({ className: "list-item list-inside hollow" }, { children: _jsx("p", __assign({ className: "text-text inline" }, { children: text[i + 1] })) })) }))] }), i));
    }
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var viewing_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_user_type; });
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    return (_jsxs("div", __assign({ className: "h-full" }, { children: [_jsx(NavBar, { viewing_user: viewing_user_type, logged_in_user: logged_in_user_type, viewing_username: viewing_username }), _jsxs("div", __assign({ className: "page-template-right" }, { children: [_jsx(PageHeader, { title: "User Guide" }), _jsxs(Card, __assign({ scrollable: true, multiLine: true }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("p", __assign({ className: "text-title" }, { children: "Key Features" })), _jsx("p", __assign({ className: "text-subtitle" }, { children: "The key features of the site that you will be interacting with are explained below." }))] })), _jsxs("ul", __assign({ className: " list-inside" }, { children: __spreadArray([], data, true) }))] }))] }))] })));
}
